import api from './api';

export const cashApi = {
  openDay: (data: Record<string, unknown>) => api.post('/api/vendor/finance/cash/open', data),
  getCurrentSession: () => api.get('/api/vendor/finance/cash/current'),
  closeDay: (data: Record<string, unknown>) => api.post('/api/vendor/finance/cash/close', data),
  addPettyCash: (data: Record<string, unknown>) => api.post('/api/vendor/finance/cash/petty', data),
  convertPettyCash: (id: number) => api.post(`/api/vendor/finance/cash/petty/${id}/convert`),
  getCashHistory: (params?: Record<string, unknown>) => api.get('/api/vendor/finance/cash/history', { params }),
  reopenDay: () => api.post('/api/vendor/finance/cash/reopen'),
};
